<template>
  <div class="creating">
    <div class="text-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { functions } from "@/components/firebase/config";
import join_game from "@/components/firebase/join_game";
export default {
  name: "Creating",
  props: {
    timer: String,
    passing: String,
    playerName: String,
  },
  async created() {
    console.log("timer", this.timer, this.parseTimer());
    console.log("passing", this.passing, this.parsePassing());
    var gameInfo = await functions.httpsCallable("newGame")({
      timer: this.parseTimer(),
      passing: this.parsePassing(),
    });
    await join_game.authorize();

    var playerInfo = await functions.httpsCallable("addPlayer")({
      gameId: gameInfo.data.gameId,
      player: this.playerName,
    });

    this.$router.push({
      name: "IndividualGame",
      params: {
        gameName: gameInfo.data.gameName,
        gameId: gameInfo.data.gameId,
        playerKey: playerInfo.data.playerKey,
      },
    });
  },
  methods: {
    parseTimer() {
      return parseInt(this.timer, 10);
    },
    parsePassing() {
      if (this.passing === "true") {
        return true;
      }
      return false;
    },
  },
  components: {},
  data() {
    return {};
  },
};
</script>
